// extracted by mini-css-extract-plugin
export default {"wrapper":"NoDocs_wrapper__+b8Bt"};